import "antd/dist/antd.css";
import React, { useState, useMemo } from "react";
import { Form, Input, Radio, Checkbox } from "antd";
import { connect } from "react-redux";
import { formatNumber } from "../../Util/util";
import { getCostSavingsMaxBreakIn, getCostSavingsMinBreakIn, getTotalBenefits } from "../Logics/benefitCalculations";
import CostPies from "../Elements/CostPies";
import BenefitsPie from "../Elements/BenefitsPie";
// import CostSankey from "../Elements/CostSankey";
// import BenefitsSankey from "../Elements/BenefitsSankey";
import useWindowResize from "../../Util/screenSize";
import { getLabel } from "../../Util/util";
import { finalMaximumCostTooltip, finalMinimumCostTooltip, summaryExplanation } from "../../Util/writing";

const smallFormItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const outputFormDivStyle = {
  marginTop: "20px",
  marginBottom: "5px",
  padding: 25,
};

const explanationDivStyle = {
  lineHeight: "1.15em",
  width: "80%",
  margin: "auto",
  paddingTop: 20,
  paddingRight: 25,
  paddingLeft: 25,
  textAlign: "left",
};

const Summary = (props) => {
  const [breakInMode, updateBreakInMode] = useState("0");
  const [showExtraVisuals, updateShowExtraVisuals] = useState(false);

  const width = useWindowResize()[0];

  const handleRadioChange = (e) => {
    updateBreakInMode(e.target.value);
  };

  const benefits = useMemo(() => getTotalBenefits(), [props.benefits]);
  const minCost = useMemo(
    () => getCostSavingsMinBreakIn(),
    [props.retrainCostDetails, props.prodLossDetails, props.systemCostDetails, props.costAdjustDetails]
  );
  const maxCost = useMemo(
    () => getCostSavingsMaxBreakIn(),
    [props.retrainCostDetails, props.prodLossDetails, props.systemCostDetails, props.costAdjustDetails]
  );

  const getRadioSize = () => {
    if (width > 700) {
      return "large";
    } else if (width > 600) {
      return "middle";
    } else {
      return "small";
    }
  };

  return (
    <React.Fragment>
      <div style={explanationDivStyle}>{summaryExplanation}</div>
      <div>
        <CostPies breakInMode={breakInMode} width={width} />
      </div>
      <div>
        <Radio.Group defaultValue="0" size={getRadioSize()} onChange={handleRadioChange}>
          <Radio.Button value="0">Use minimum break in</Radio.Button>
          <Radio.Button value="1">Use average break in</Radio.Button>
          <Radio.Button value="2">Use maximum break in</Radio.Button>
        </Radio.Group>
      </div>
      <div>
        <Checkbox onChange={() => updateShowExtraVisuals(!showExtraVisuals)} id="showBenefits">
          Show benefits breakdown
        </Checkbox>
      </div>

      {/* Benefits pie */}
      {showExtraVisuals && (
        <div>
          <BenefitsPie width={width} />
        </div>
      )}

      {/* Sankey diagrams */}
      {/* <div>
        <CostSankey breakInMode={breakInMode} width={width} visible={showExtraVisuals} />
      </div>
      <div>
        <BenefitsSankey breakInMode={breakInMode} width={width} visible={showExtraVisuals} />
      </div> */}

      {/* Output text boxes */}
      <div style={outputFormDivStyle}>
        <Form {...smallFormItemLayout}>
          <Form.Item label="Total Benefits" help="">
            <Input
              addonAfter={props.currency}
              placeholder=""
              id="inflation-adjusted-benefits-summary"
              disabled
              value={formatNumber(benefits)}
            />
          </Form.Item>
          <Form.Item label={getLabel("Final Minimum Cost", finalMinimumCostTooltip)} help="">
            <Input
              addonAfter={props.currency}
              placeholder=""
              id="inflation-adjusted-max-cost"
              disabled
              value={formatNumber(minCost)}
            />
          </Form.Item>
          <Form.Item label={getLabel("Final Maximum Cost", finalMaximumCostTooltip)} help="">
            <Input
              addonAfter={props.currency}
              placeholder=""
              id="inflation-adjusted-min-cost"
              disabled
              value={formatNumber(maxCost)}
            />
          </Form.Item>
        </Form>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    currency: state.currency.currency,
    benefits: state.benefits.benefitsDetails,
    retrainCostDetails: state.costs.retrainCostDetails,
    prodLossDetails: state.costs.prodLossDetails,
    systemCostDetails: state.costs.systemCostDetails,
    costAdjustDetails: state.costs.costAdjustDetails,
  };
};

export default connect(mapStateToProps, null)(Summary);
